var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-row',[_c('v-col',{staticClass:"text-center pt-12",attrs:{"shrink":""}},[_c('p',{staticClass:"title"},[_vm._v("Logging out.")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }